import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

const About = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <SEO 
        title="About Us | Newsmedia Association of India"
        description="Learn about NAI, India's premier multi-media journalists & professionals protection forum. Our mission is to defend and promote press freedom."
        keywords="About NAI, Media Protection Forum, Journalism Ethics, Press Freedom Mission"
      />
      {/* Hero Section */}
      <section 
        className="relative bg-blue-900 text-white py-20 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: "url('/images/aboutnai.webp')" }}
      >
        <div className="absolute inset-0 bg-blue-900/80"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-5xl md:text-6xl font-bold mb-6">About NAI</h1>
            <p className="text-xl md:text-2xl text-blue-100 max-w-4xl mx-auto">
              India's Premier Multi-Media Journalists & Professionals Protection
              Forum
            </p>
          </div>
        </div>
      </section>

      {/* Introduction Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-8">
                Welcome to Newsmedia Association of India
              </h2>
              <div className="space-y-6 text-gray-700 text-lg leading-relaxed">
                <p>
                  It brings us great pleasure to introduce you to the NAI, the
                  Newsmedia Association of India, India's number one source for
                  multi-media journalist's & professional's protection forum.
                  Which covers Print media, Broadcasting media, Digital media &
                  Cine Media.
                </p>
                <p>
                  NAI, the Newsmedia Association of India, is an alliance of new
                  media companies whose members provide new media platforms
                  offering consumers a wide range of online services, including
                  e-content, media, E-commerce, communications and
                  information/search services.
                </p>
              </div>
            </div>
            <div className="flex justify-center">
              <div className="w-full h-80 rounded-2xl overflow-hidden shadow-xl transform hover:scale-105 transition-transform duration-300">
                <img 
                  src="/images/nai_organization.png" 
                  alt="Newsmedia Association of India Organization" 
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Our Mission & Vision
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Driving innovation and cooperation in Indian journalism across all
              media platforms
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <svg
                  className="w-8 h-8 text-blue-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M13 10V3L4 14h7v7l9-11h-7z"
                  />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Our Mission
              </h3>
              <p className="text-gray-700 leading-relaxed">
                To support all kinds of organizations and media outlets, to
                define a vision for the future of journalism and enhance its
                quality through innovation and cooperation. Freedom of
                information and independence of the news media are, and will
                remain, the main credo of NAI.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6">
                <svg
                  className="w-8 h-8 text-green-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                  />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Our Vision
              </h3>
              <p className="text-gray-700 leading-relaxed">
                To be India's leading alliance of new media companies,
                representing the interests of the new media sector in
                policymaking, driven by a journalistic imperative and a common
                goal: Content and Engagement First.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* History Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="order-2 lg:order-1">
              <div className="w-full h-80 rounded-2xl overflow-hidden shadow-xl transform hover:scale-105 transition-transform duration-300">
                <img 
                  src="/images/nai_history.png" 
                  alt="Newsmedia Association of India History" 
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
            <div className="order-1 lg:order-2">
              <h2 className="text-4xl font-bold text-gray-900 mb-8">
                Our President
              </h2>
              <div className="space-y-6 text-gray-700 text-lg leading-relaxed">
                <p>
                  A. Charles is the National President of the organization and has
                  served as the Chief Editor of Police News Plus since 2013,
                  guiding its editorial vision and growth.
                </p>
                <p>
                  His journey in media began in 2007, when he started his career as
                  the Chief Editor of Indhiya Sudar, a print newspaper. Since
                  then, he has been a dedicated presence in journalism,
                  transitioning from print media to digital platforms while staying
                  committed to accurate, impactful reporting.
                </p>
                <p>
                  With over a decade of leadership at Police News Plus, A. Charles
                  continues to shape the organization's mission of connecting
                  communities with the police force and highlighting stories that
                  matter.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Formation & Registration */}
      <section className="py-20 bg-blue-600 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-4">Official Formation</h2>
            <p className="text-xl text-blue-100 max-w-2xl mx-auto">
              The birth of India's first technology-focused multi-media
              association
            </p>
          </div>

          <div className="bg-blue-500 rounded-2xl p-8 max-w-4xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div>
                <h3 className="text-2xl font-bold mb-4">2012: The Vision</h3>
                <p className="text-blue-100 leading-relaxed">
                  In 2012, we decided to form an association of many news media.
                  In this association, along with Print media, Broadcast media,
                  Digital media we also brought in the Cine media. For the first
                  time in India, this is the only association formed with
                  technology as its objective.
                </p>
              </div>
              <div>
                <h3 className="text-2xl font-bold mb-4">
                  2013: Official Registration
                </h3>
                <p className="text-blue-100 leading-relaxed">
                  In the year 2013, we registered this association with the
                  government. The government registration number is{" "}
                  <strong>SRACTXXVII of 1975 SL.No.165 of 2013</strong>. NAI is
                  a Unit of DMCR Newsmedia Association Regd. by Govt. of India
                  under Section 8 Act 2013.
                </p>
              </div>
              <div className="md:col-span-2">
                <h3 className="text-2xl font-bold mb-4">
                  2022: Registration of DMCR Newsmedia Association
                </h3>
                <p className="text-blue-100 leading-relaxed">
                  In the year 2013, we registered this association with the
                  government of India under section 8 of the Companies Act,
                  2013. The government registration number is{" "}
                  <strong>SRACTXXVII of 1975 SL.No.165 of 2013</strong>. NAI is
                  a Unit of DMCR Newsmedia Association Regd. by Govt. of India
                  under Section 8 Act 2013.	The main objective is Social welfare activities, 
                  to protect the democracy,  rights of  citizen reporters, 
                  media welfare,  to encourage / assist talented writers, 
                  editors, reporters, photo journalists, News readers, 
                  video cameramen, News agency, Advertisement agency, 
                   artists, poets, singers, social workers, to promote commerce, 
                    education, art, science, sports, social  welfare, protection of 
                    human rights, environmental protection, helping economically  
                    weaker people medical  support  for poor peoples, rural  development  
                    including  any programme for promoting the social and economic welfare
                     of  or the  uplift of the public in any rural area or any other such  
                     objective provided  the  profits, if any, or other  income is applied 
                     for promoting the objectives of the company. 
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Media Coverage Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Media Coverage
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Comprehensive protection and representation across all media
              platforms
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              {
                title: "Print Media",
                icon: "📰",
                description:
                  "Newspapers, magazines, and traditional print publications",
              },
              {
                title: "Broadcast Media",
                icon: "📺",
                description: "Television and radio broadcasting networks",
              },
              {
                title: "Digital Media",
                icon: "💻",
                description:
                  "Online platforms, websites, and digital publications",
              },
              {
                title: "Cine Media",
                icon: "🎬",
                description: "Film industry and cinematic journalism",
              },
            ].map((media, index) => (
              <div
                key={index}
                className="bg-white p-6 rounded-xl shadow-lg border border-gray-100 text-center"
              >
                <div className="text-4xl mb-4">{media.icon}</div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {media.title}
                </h3>
                <p className="text-gray-600 text-sm">{media.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Journalist Community Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl font-bold text-gray-900 mb-8">
              Our Commitment to Journalists
            </h2>
            <div className="space-y-6 text-gray-700 text-lg leading-relaxed">
              <p>
                Journalist community was an active participant in the freedom
                struggle and suffered the same fate as the other
                freedom-fighters. But they have not been treated like freedom
                fighters. Politicians are always against Journalist community.
              </p>
              <p>
                We are convinced that news producers and newsrooms across all
                platforms – print, broadcast, online, mobile and Cine media
                services – face comparable challenges. To that end, we support
                all kinds of organizations and media outlets.
              </p>
              <p className="font-semibold text-blue-600">
                Freedom of information and independence of the news media are,
                and will remain, the main credo of the Newsmedia Association of
                India and we will back all efforts to enhance press freedom
                worldwide.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-red-600 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">Join the NAI Community</h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto text-red-100">
            Become part of India's leading multi-media association and help
            shape the future of journalism.
          </p>
          <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-6">
            <Link 
              to="/apply"
              className="bg-white text-red-600 hover:bg-gray-100 px-8 py-4 rounded-lg font-semibold text-lg transition-colors duration-300 inline-block"
            >
              Become a Member
            </Link>
            <Link 
              to="/contact"
              className="border-2 border-white hover:bg-white hover:text-red-600 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-colors duration-300 inline-block"
            >
              Contact Us
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
